import colors from '../../../../themes/colors';
export var sizeMixin = function (_a) {
    var heroUrl = _a.heroUrl, size = _a.size;
    if (!heroUrl)
        return '';
    var isTile = size === 'tile';
    var isTile2 = size === 'tile2';
    var height = '148px';
    if (isTile)
        height = '272px';
    if (isTile2)
        height = '302px';
    return "\n    overflow: hidden;\n    border-radius: 6px 6px 0 0;\n    align-items: flex-start;\n    height: ".concat(height, ";\n  ");
};
export var bgMixin = function (_a) {
    var heroUrl = _a.heroUrl, size = _a.size;
    if (!heroUrl)
        return '';
    var isTile = size === 'tile';
    var isTile2 = size === 'tile2';
    var bgSize = 'cover';
    var bgColor = colors.neutral0;
    var bgImg = "url(".concat(heroUrl, ")");
    if (isTile || isTile2) {
        bgSize = 'contain';
        bgColor = colors.neutral90;
        // this is how you add an overlay to the image
        // TODO(Jenky): figure out why I added this overlay
        // bgImg = `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${heroUrl})`;
        bgImg = "url(".concat(heroUrl, ")");
    }
    return "\n    background-color: ".concat(bgColor, ";\n    background-image: ").concat(bgImg, ";\n    background-size: ").concat(bgSize, ";\n    background-position: center;\n    background-repeat: no-repeat;\n  ");
};
export var alignmentMixin = function (_a) {
    var heroUrl = _a.heroUrl;
    if (!heroUrl) {
        return "\n    & > * {\n      align-items: center\n    }\n    ";
    }
    return 'align-items: flex-start';
};
